(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/envelope/assets/javascripts/components/content-images.js') >= 0) return;  svs.modules.push('/components/tur/envelope/assets/javascripts/components/content-images.js');
"use strict";


const {
  Image
} = svs.content.image_v2;
const {
  useEffect,
  useRef,
  memo
} = React;
const generateKey = (image, index) => "".concat(image.url, "_").concat(index);
const ImageMemo = memo(_ref => {
  let {
    cssSelectors,
    image
  } = _ref;
  return React.createElement(Image, {
    cssSelectors: cssSelectors,
    image: image
  });
});
const ContentImages = _ref2 => {
  let {
    images
  } = _ref2;
  const contentImgRef = useRef(null);
  useEffect(() => {
    gsap.to('.envelope-content-animation', {
      duration: 1,
      ease: 'elastic.out(1,0.3)',
      y: -35,
      rotation: 7
    });
  }, [images]);
  useEffect(() => {
    if (contentImgRef.current) {
      contentImgRef.current.style.setProperty('--number-of-images', Math.min(images.length, 5));
    }
  }, []);
  return React.createElement("div", {
    className: "content-images",
    ref: contentImgRef
  }, images.map((image, index) => {
    const cls = ['content-image', 'envelope-content-animation'];
    if (image.width > image.height) {
      cls.push('wide');
    }
    return React.createElement(ImageMemo, {
      cssSelectors: cls.join(' '),
      image: image,
      key: generateKey(image, index)
    });
  }));
};
setGlobal('svs.tur.envelope.components.ContentImages', ContentImages);

 })(window);